'use strict';

angular
    .module('App.v1.Services')
    .factory('App.v1.Services.DeploymentDetection', ["$http", "$interval", "$log", "$rootScope",
        function ($http, $interval, $log, $rootScope) {

            var STORAGE_KEY = 'snapdesk:appVersion';
            var POLL_INTERVAL = 600 * 1000; //600000; // 10 minutes in milliseconds
            var pollingInterval = null;

            /**
             * Initialize deployment detection service
             * @param {string} initialVersion - The initial app version from the server (typically from ViewBag)
             */
            function initialize(initialVersion) {
                
                // Store initial version in localStorage for testing/mocking purposes
                if (initialVersion) {
                    localStorage.setItem(STORAGE_KEY, initialVersion);
                    $log.info('Deployment Detection: Initialized with version - ' + initialVersion);
                }

                // Perform initial check immediately
                checkForDeployment();

                // Start polling every 10 minutes
                pollingInterval = $interval(function() {
                    checkForDeployment();
                }, POLL_INTERVAL);
            }

            /**
             * Check if a new deployment has occurred by comparing versions
             * @private
             */
            function checkForDeployment() {
                $http.get('/api/deploymentinfo')
                    .then(function(response) {
                        if (response.data && response.data.version) {
                            var newVersion = response.data.version;
                            var currentVersion = localStorage.getItem(STORAGE_KEY);

                            // Version mismatch - deployment detected
                            if (currentVersion && currentVersion !== newVersion) {
                                $rootScope.$broadcast('deploymentDetected', newVersion);
                            }
                        }
                    })
                    .catch(function(error) {
                        $log.error('Deployment Detection: Failed to fetch version info', error);
                    });
            }

            /**
             * Stop polling and clean up resources
             * Called when scope is destroyed
             * @private
             */
            function stopPolling() {
                if (pollingInterval) {
                    $interval.cancel(pollingInterval);
                    pollingInterval = null;
                    $log.info('Deployment Detection: Polling stopped');
                }
            }

            /**
             * Public API
             */
            return {
                initialize: initialize,
                stop: stopPolling
            };
        }]);
